import {
  ApiBlobGetRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Daftar Absensi Karyawan',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Absensi Karyawan',
        href: '/adm/absensi',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_absensi',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      // {
      //   key: 'kode_absensi',
      //   label: 'Kode',
      //   sortable: true,
      // },
      {
        key: 'nm_karyawan',
        label: 'Nama Karyawan',
        sortable: true,
      },
      // {
      //   key: 'nama_pabrik',
      //   label: 'Pabrik',
      // },
      {
        key: 'nm_dept',
        label: 'Dept',
        sortable: true,
      },
      {
        key: 'tgl_absensi',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'tipe',
        label: 'Tipe',
        sortable: true,
      },
      {
        key: 'jam_kerja',
        label: 'Jam Kerja',
        sortable: true,
      },
      {
        key: 'status_kerja',
        label: 'Status',
        sortable: true,
      },
      {
        key: 'ket_absensi',
        label: 'Keterangan',
        sortable: true,
        thStyle: {
          minWidth: '300px',
        },
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeAbsensi(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchAbsensi(context, params = null) {
    let result = await ApiGetRequest(`absensi`, params);
    return !result.error ? result.data.object : [];
  },

  async getTotalNotApproveAbsensi(context, params = null) {
    let result = await ApiGetRequest(`absensi/not-approve`, params);
    return !result.error ? (result.data.object ? result.data.object : 0) : 0;
  },

  async getListAbsensi({ commit, state }, payload = {}) {
    commit('changeAbsensi', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`absensi`, params);
      commit('changeAbsensi', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_absensi_karyawan.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        commit('changeAbsensi', {
          loading: false,
        });

        return true;
      }
    } else {
      let result = await ApiGetRequest(`absensi`, params);
      commit('changeAbsensi', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailAbsensi({ commit }, payload = null) {
    commit('changeAbsensi', {
      loading: true,
    });

    let result = await ApiGetRequest(`absensi/${payload.id}`);
    commit('changeAbsensi', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadFileAbsensi({ commit, state }, payload) {
    commit('changeAbsensi', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-files`, payload);
    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      commit('changeAbsensi', {
        form: {
          ...data.form,
          file_absensi: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeAbsensi', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`absensi/import`, {
      items: data.import_form || [],
    });

    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createAbsensi({ commit, state, dispatch }) {
    commit('changeAbsensi', {
      loading: true,
    });

    let result = await ApiPostRequest(`absensi`, state.data.form);
    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateAbsensi({ commit, state, dispatch }, payload = null) {
    commit('changeAbsensi', {
      loading: true,
    });

    let result = await ApiPutRequest(`absensi/${payload.id}`, state.data.form);

    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteAbsensi({ commit, dispatch }, payload = null) {
    commit('changeAbsensi', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`absensi/${payload.id}`);
    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async approveAbsensi({ commit, dispatch }, payload = null) {
    commit('changeAbsensi', {
      loading: true,
    });

    let result = await ApiGetRequest(`absensi/${payload.id}/${payload.status}`);
    commit('changeAbsensi', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
